import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from 'src/app/services/language.service';

/** TBD after new login implemented */

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements OnInit {

  public message: string = "";

  constructor(private router: Router, private languageService:LanguageService) { }

  ngOnInit(): void {
    if (this.router.url.includes("permission-error")) {
      this.message = this.languageService.languageJSON.Login_Error;
    }
    else {
      this.router.navigate(["/software-overview"]);
    }
  }
}
